export default __webpack_public_path__ + "checkered-raised-flag.png";